<section class="main">
  <h3>
    <span>
      <img
        style="cursor: pointer"
        (click)="back()"
        src="assets/images/mangeunit/back.png"
      />
    </span>
    Edit client
  </h3>
  <mat-tab-group>
    <mat-tab label="Images">
      <section class="images_main mt-3">
        <div class="row">
          <div class="col-md-3" *ngFor="let item of clients_image">
            <div class="card_image mt-2">
              <img class="img-fluid imageSize" [src]="item.image" />
              <p class="mt-2">{{ item.image_type }}</p>
              <div class="deleteImageSize">
                <img
                  (click)="deletImage(item.id)"
                  src="assets/images/delete.png"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="addImage">
          <div class="mt-3">
            <div class="row align-items-center" *ngIf="showInputFile">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>Image Type</mat-label>
                  <mat-select
                    [(ngModel)]="typeDocName"
                    (selectionChange)="typechoose($event.value)"
                  >
                    <!-- personal_photo -->
                    <mat-option value="personal_photo">
                      Personal photo
                    </mat-option>
                    <mat-option value="Passport-ID">
                      ID/Passport
                    </mat-option>
                    <mat-option value="Drivers License">
                      Drivers License
                    </mat-option>
                    <mat-option value="Birth Certificate">
                      Birth Certificate
                    </mat-option>
                    <mat-option value="Other">
                      Other
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-4">
                <input
                  type="file"
                  multiple
                  (change)="uploadDocmentsClient($event)"
                />
              </div>
            </div>
            <div *ngIf="status_input_type_name">
              <div class="row">
                <div class="col-6">
                  <label>Image Type Name</label>
                  <input
                    (input)="inputChange($event)"
                    [(ngModel)]="typeInputName"
                    type="text"
                    class="form-control mb-2"
                  />
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="userDocEditPhtot" class="d-flex mt-3">
            <div
              class="imageUserUlpoad docmentsImages ms-3 "
              *ngFor="let item of docmentImage"
            >
              <span (click)="removeDocImage(item)">X</span>
              <img *ngIf="item.file == false" [src]="item.url" />
              <p *ngIf="item.file == true">{{ item.url }}</p>
              <h5>{{ item.name }}</h5>
            </div>
          </div>

          <button *ngIf="!showInputFile" class="btn" (click)="addImage()">
            Add Image
          </button>
          <button *ngIf="showInputFile" class="btn" (click)="createImage()">
            Save
          </button>
        </div>
      </section>
    </mat-tab>
    <mat-tab label="Information">
      <section class="supmain mt-3" *ngIf="validForm">
        <p>Units</p>
        <div class="row">
          <div class="col-md-3">
            <label>Unit name</label>
            <input
              [(ngModel)]="unitNameSearch"
              (input)="searchUnit($event)"
              placeholder="Find Unit"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <label>Relation</label>
            <input
              [(ngModel)]="unitRelation"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-md-3">
            <button class="btn  addUnit" (click)="addUnit()">Add Unit</button>
          </div>
        </div>
        <div class="listSearch" *ngIf="unitSearch_arr.length != 0">
          <ul>
            <li (click)="getUnit(item)" *ngFor="let item of unitSearch_arr">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="mt-2">
          <div class="row">
            <div class="col-6">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">Unit name</th>
                    <th scope="col">Unit Realtion</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of array_unit; let i = index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.relation }}</td>
                    <td>
                      <img
                        class="deleteImage"
                        (click)="deleteUnit(i)"
                        src="assets/images/delete.png"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <form [formGroup]="clientForm">
          <!-- persona info -->
          <div class="mt-4 mb-4">
            <p>Personal information</p>
            <div class="row mb-2">
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label>Client name (EN)</label>
                  <input
                    formControlName="name"
                    [ngClass]="{
                      'is-invalid': submitted && ControlForm.name.errors
                    }"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label>Client name (AR)</label>
                  <input
                    formControlName="arabic_name"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="row mb-2">
                              <div class="col-3">
                                  <div class="form-group">
                                      <label>National ID number</label>
                                      <input type="number" class="form-control">
                                  </div>
                              </div>
                          </div> -->

            <div class="row">
              <div class="col-12 col-md-3">
                <label>Birth date</label>
                <div class="d-flex align-items-center datePicker">
                  <input
                    formControlName="birth_date"
                    [ngClass]="{
                      'is-invalid': submitted && ControlForm.birth_date.errors
                    }"
                    class="form-control"
                    placeholder="Form"
                    [matDatepicker]="picker"
                  />
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 col-md-3">
                <p>Gender</p>
                <input
                  formControlName="gender"
                  type="radio"
                  id="male"
                  value="Male"
                />
                <label class="ms-2" for="male">Male</label><br />
                <input
                  formControlName="gender"
                  type="radio"
                  id="female"
                  value="Female"
                />
                <label class="ms-2" for="female">Female</label>
                <div
                  class="invalid-feedback"
                  *ngIf="submitted && ControlForm.gender.errors"
                >
                  Gender is Required
                </div>
              </div>
            </div>

            <div class="row mt-2 ">
              <div class="col-12 col-md-3">
                <p>Status</p>
                <input
                  formControlName="verified"
                  type="checkbox"
                  id="Verified"
                  value="true"
                />
                <label class="ms-2" for="Verified">Verified</label><br />
                <input
                  formControlName="activated"
                  type="checkbox"
                  id="Activated"
                  value="true"
                />
                <label class="ms-2" for="Activated">Activated</label>
              </div>
            </div>

            <!-- <div class="row mb-3">
              <label>Relation type</label>
              <div class="dropdown mb-0 ">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ typeName }}
                  <img src="assets/images/mangeunit/arrow.png" />
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li
                    *ngFor="let item of types_arr"
                    (click)="getRelationTypeId(item)"
                  >
                    <a class="dropdown-item">{{ item.name }}</a>
                  </li>
                </ul>
              </div>
              <div class="invalid-feedback" *ngIf="submitted && typeId == ''">
                Relation type is Required
              </div>
            </div> -->
          </div>

          <!-- Contact information -->
          <div>
            <p>Contact information</p>
            <div class="row mb-2">
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label>Email</label>
                  <input
                    [ngClass]="{
                      'is-invalid': submitted && ControlForm.email.errors
                    }"
                    formControlName="email"
                    type="email"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label>Phone number</label>
                  <input
                    [ngClass]="{
                      'is-invalid': submitted && ControlForm.phone_number.errors
                    }"
                    formControlName="phone_number"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 col-md-3">
                <div class="form-group">
                  <label>National id</label>
                  <input
                    [ngClass]="{
                      'is-invalid': submitted && ControlForm.national_id.errors
                    }"
                    formControlName="national_id"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="row mb-2">
                              <div class="col-3">
                                  <div class="form-group">
                                      <label>Adress</label>
                                      <input type="text" class="form-control">
                                  </div>
                              </div>
                          </div>
                          <div class="row ">
                              <div class="col-3">
                                  <div class="form-group">
                                      <label>Social link 1</label>
                                      <input type="text" class="form-control">
                                  </div>
                              </div>
                              <div class="col-3">
                                  <div class="form-group">
                                      <label>Social link 2</label>
                                      <input type="text" class="form-control">
                                  </div>
                              </div>
                          </div> -->
          </div>

          <!-- Other information -->

          <div class="mt-4">
            <p>Other information</p>

            <!-- <div class="row mb-2">
                              <div class="col-3">
                                  <div class="form-group">
                                      <label>Extension ID</label>
                                      <input type="text" class="form-control">
                                  </div>
                              </div>
                          </div> -->
            <div class="row mb-3">
              <!-- <div class="col-3">
                                  <div class="form-group">
                                      <label>Relation type</label>
                                      <input type="text" class="form-control">
                                  </div>
                              </div> -->
              <!-- <label>Relation type</label>
                              <div class="dropdown mb-0 ">
                                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                                      data-bs-toggle="dropdown" aria-expanded="false">
                                      {{typeName}}
                                      <img src="assets/images/mangeunit/arrow.png">
                                  </button>
                                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                      <li *ngFor="let item of types_arr" (click)="getRelationTypeId(item)">
                                          <a class="dropdown-item">{{item.name}}</a>
                                      </li>
                                  </ul>
                              </div>
                              <div class="invalid-feedback" *ngIf="submitted && (typeId == '')">Relation type is Required</div> -->
            </div>
            <!-- <div class="row mb-2">
                              <div class="col-3">
                                  <input type="checkbox">
                                  <label class="ms-1">This client is temporary</label>
                              </div>
                          </div> -->
            <div class="row">
              <div class="col-12 col-md-3">
                <label>From</label>
                <div class="d-flex align-items-center datePicker">
                  <input
                    formControlName="valid_from"
                    [ngClass]="{
                      'is-invalid': submitted && ControlForm.valid_from.errors
                    }"
                    class="form-control"
                    placeholder="Valid Form"
                    [matDatepicker]="pickerform"
                  />
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="pickerform"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerform></mat-datepicker>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <label>To</label>
                <div class="d-flex align-items-center datePicker">
                  <input
                    formControlName="valid_to"
                    [ngClass]="{
                      'is-invalid': submitted && ControlForm.valid_to.errors
                    }"
                    class="form-control"
                    placeholder="Valid To"
                    [matDatepicker]="pickertow"
                  />
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="pickertow"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickertow></mat-datepicker>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex  justify-content-end mt-5 mb-2">
            <div>
              <button class="btn me-2">Cancel</button>
              <button class="btn next" (click)="editClient()">
                Edit Client
              </button>
            </div>
          </div>
        </form>
      </section>
    </mat-tab>
    <mat-tab label="RFID">
      <mat-tab-group>
        <mat-tab label="RFID List">
          <section class="tableUnit table-responsive mt-3">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Card id</th>
                  <th scope="col">License plate</th>
                  <th scope="col" class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of rfid_list; let i = index">
                  <td class="">
                    {{ item.id }}
                  </td>
                  <td>
                    <span>{{ item.card_id }}</span>
                  </td>
                  <td>
                    {{ item.license_plate }}
                  </td>
                  <td class="text-end">
                    <div class="icons_actions">
                      <img
                        mat-raised-button
                        matTooltip="View"
                        matTooltipClass="example-tooltip-uppercase"
                        [matTooltipPosition]="'above'"
                        (click)="openViewRFID(item)"
                        src="assets/images/view.png"
                      />

                      <img
                        mat-raised-button
                        matTooltip="Edit"
                        matTooltipClass="example-tooltip-uppercase"
                        [matTooltipPosition]="'above'"
                        (click)="editRFID(item)"
                        class="ms-2"
                        src="assets/images/edits.png"
                      />

                      <img
                        mat-raised-button
                        matTooltip="Delete"
                        matTooltipClass="example-tooltip-uppercase"
                        [matTooltipPosition]="'above'"
                        (click)="deleteRfid(item)"
                        class="ms-2"
                        src="assets/images/delete.png"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <h3 *ngIf="rfid_list.length == 0">No Data Found</h3>
          </section>
        </mat-tab>

        <mat-tab label="Add RFID">
          <section class="mt-3">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="RfidForm">
                  <div class="col-md-12">
                    <label>Vechicle Number </label>
                    <div class="row">
                      <div class="col-md-6">
                        <input
                          formControlName="number"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="col-md-2">
                        <input
                          formControlName="charOne"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="col-md-2">
                        <input
                          formControlName="charTow"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="col-md-2">
                        <input
                          formControlName="charThree"
                          type="text"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 mt-3">
                    <label>Driving License Front Face</label>
                    <input
                      (change)="onFileChange($event, 'front')"
                      formControlName="front"
                      type="file"
                    />
                  </div>
                  <div class="col-md-12 mt-3">
                    <label>Driving License Back Face</label>
                    <input
                      (change)="onFileChange($event, 'back')"
                      formControlName="back"
                      type="file"
                    />
                  </div>
                  <div class="col-md-12 mt-3">
                    <label>Car Tag </label>
                    <input
                      formControlName="card_id"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-12 mt-3">
                    <label>Serial Number </label>
                    <input
                      formControlName="serial_number"
                      type="text"
                      class="form-control"
                    />
                  </div>
                </form>
                <button class="btn next mt-4" (click)="addRfid()">Save</button>
              </div>
            </div>
          </section>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>
  </mat-tab-group>
</section>
